import React, { useState, useEffect } from 'react'
import { usePaymentInputs } from 'react-payment-inputs'
import images from 'react-payment-inputs/images'
const AddCard = props => {
  const t = t => {
    return t
  }
  const { hasDefaultNameField, cardDataCb, isCardSaved } = props
  const ERROR_MESSAGES = {
    emptyCardNumber: 'do111111111',
    invalidCardNumber: '12o',
    emptyExpiryDate: 'La fecha de expiración es inválida',
    monthOutOfRange: 'El mes de expiración debe estar entre 01 y 12',
    yearOutOfRange: 'El año de expiración no puede estar en el pasado',
    dateOutOfRange: 'La fecha de expiración no puede estar en el pasado',
    invalidExpiryDate: 'La fecha de expiración es inválida',
    emptyCVC: 'El código de seguridad es inválido',
    invalidCVC: 'El código de seguridad es inválido',
  }
  const {
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps,
    getCardImageProps,
  } = usePaymentInputs({
    errorMessages: ERROR_MESSAGES,
  })
  const [cardNumber, setCardNumber] = useState('')
  const [expiryDate, setExpiryDate] = useState('')
  const [cardName, setCardName] = useState('')
  const [cvc, setCvc] = useState('')
  const handleChangeCardNumber = ({ target: { value } }) => {
    setCardNumber(value)
  }
  const handleChangeCardName = ({ target: { value } }) => {
    setCardName(value)
  }
  const handleChangeExpiryDate = ({ target: { value } }) => {
    setExpiryDate(value)
  }
  const handleChangeCVC = ({ target: { value } }) => {
    setCvc(value)
  }
  useEffect(() => {
    const data = {
      cardNumber: cardNumber.replaceAll(' ', ''),
      expiryDate,
      cvc,
    }
    if (isCardSaved || hasDefaultNameField) {
      data.cardName = cardName
    }
    cardDataCb && cardDataCb(data)
  }, [
    cardName,
    cardNumber,
    expiryDate,
    cvc,
    isCardSaved,
    hasDefaultNameField,
  ])
  return (
    <div className='new-card'>
        <div className='new-card__form-card-items border-radius'>
          {(hasDefaultNameField || isCardSaved) && (
            <div>
              <label className='new-card__form-item new-card__form-top'>
                <span>{t('cardName')}</span>
                <input
                  className='border-radius'
                  onChange={handleChangeCardName}
                  value={cardName}
                  placeholder={`${t('cardName')}`}
                />
              </label>
            </div>
          )}
          <label className='new-card__form-item new-card__form-top'>
            <span>{t('cardNumber')}</span>
            <svg
              className='new-card__form-item-card-icon'
              {...getCardImageProps({ images: images })}
            />
            <input
              className='border-radius'
              {...getCardNumberProps({ onChange: handleChangeCardNumber })}
              value={cardNumber}
              placeholder='••••  ••••  ••••  ••••'
            />
          </label>
          <div className='new-card__form-item new-card__form-bottom'>
            <label className='new-card__form-bottom-left'>
              <span>{t('expirationDate')}</span>
              <input
                className='border-radius'
                {...getExpiryDateProps({ onChange: handleChangeExpiryDate })}
                value={expiryDate}
                placeholder='•• / ••'
              />
            </label>
            <label className='new-card__form-bottom-right'>
              <span>CVV / CVC</span>
              <input
                className='border-radius'
                {...getCVCProps({ onChange: handleChangeCVC })}
                value={cvc}
                placeholder='•••'
              />
            </label>
          </div>
        </div>
    </div>
  )
}
export default AddCard
